import { useOrganizationContext, usePermissionsContext } from '../../context';

/**
 * Whether the account may use the locker-key desk in the active organization —
 * the same gate as every backend locker route (`locker_keys_manage`:
 * organization owner, solo-PT owner, front desk, plus custom roles that were
 * granted it). `/auth/me` carries the active organization's permissions.
 */
export default function useCanManageLockerKeys() {
  const { hasPermission } = usePermissionsContext();
  const { currentOrganization } = useOrganizationContext();
  // A super admin can switch Keys off for an organization.
  return (
    currentOrganization?.lockerKeysEnabled !== false &&
    hasPermission('locker_keys_manage')
  );
}
